const config = {
  APP_ID: 'controlling',
  DEFAULT_LIST_LIMIT: 50,
  APPLICATION_NS: 'APPLICATION',
  PROCEDURES_NS: 'PROCEDURES',
  INSTANCES_NS: 'INSTANCES',
};

export default config;
